<div class="flex gap-3">
  <!-- Search Input and Filters -->
  <app-filters *appHasPermission="['get_all_order', 'can_get_all_mfd_trx_request']"  [filters]="filterStructure"></app-filters>
  <app-table-refresh class="mt-5" [tableKey]="'orderApprovals'"></app-table-refresh>
</div>
<!-- Client Table -->
<!-- table skeleton loader -->
 @if (isFetchingOrderList$ | async) {
<div *appHasPermission="['get_all_order', 'can_get_all_mfd_trx_request']" class="mt-[0.94rem]">
  <app-table-skeleton-loader></app-table-skeleton-loader>
</div>
}

@if(!(isFetchingOrderList$ | async)) {
<div
*appHasPermission="['get_all_order', 'can_get_all_mfd_trx_request']"
  class="mt-[0.94rem] rounded-lg border border-solid border-gray-200 bg-white"
>
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
      <div
        class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      >
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="flex border-b-2 border-gray-200 bg-gray-100 px-5 py-4 text-left text-xs font-semibold text-gray-600"
              >
                S/N
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M7.99998 3.33301V12.6663M7.99998 12.6663L12.6666 7.99967M7.99998 12.6663L3.33331 7.99967"
                    stroke="#667085"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Date Created
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                User / Organisation
              </th>

              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Order Type  
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Amount
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Maker
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Checker
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Value Date
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
              >
                Status
              </th>
              <th
                class="border-b-2 border-gray-200 bg-gray-100 px-5 py-2 text-left text-xs font-semibold tracking-wider text-gray-600"
              ></th>
            </tr>
          </thead>
          <tbody>
              @for (order of (orderList$ | async); track order.id; let i = $index) {
                <tr>
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p>{{ i + 1 }}</p>
                  </td>
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ order.created_at | date: 'medium' }}
                    </p>
                  </td>
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                        {{ formatOrderName(order.name) }}
                    </p>
                  </td>
                  <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                     <span
                    class="relative inline-block px-2 py-1 font-semibold leading-tight text-green-900 sm:px-2"
                  >
                    <span
                      aria-hidden
                      class="absolute inset-0 {{
                        order.order_type === 'invest' ||
                        order.order_type === 'subscription'
                          ? 'bg-green-200'
                          : 'bg-orange-300'
                      }} opacity-50 rounded-full"
                    ></span>
                    <span
                      class="relative flex  {{
                        order.order_type === 'invest' ||
                        order.order_type === 'subscription'
                          ? 'text-[#027A48]'
                          : 'text-orange-700'
                      }} sm:text-[11px]"
                    >
                      {{ order.order_type | uppercase }}</span
                    >
                  </span>
                  </td>
                   <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                        {{ order.amount / 100 | number:'1.2-2' }}
                    </p>
                  </td>
                   <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                        {{ (order.order_by  | titlecase) || '—' }}
                    </p>
                  </td>
                   <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                        {{ (order.approved_by | titlecase) || '—' }}
                    </p>
                  </td>
                   <td
                    class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                  >
                    <p class="whitespace-no-wrap text-gray-900">
                      {{ order.value_date | date: 'MMM d yyyy' }}
                    </p>
                  </td>
                  <td
                    class="border-b border-gray-200 bg-white px-2 py-2 text-xs sm:px-3 sm:py-3 sm:text-sm md:px-4 md:py-4 lg:px-5"
                  >
                    <span
                      class="relative inline-block px-2 py-1 font-semibold leading-tight text-green-900 sm:px-2"
                    >
                      <span
                        aria-hidden
                        class="absolute inset-0 {{
                          order.status === 'approved'
                            ? 'bg-green-200'
                            : 'bg-red-300'
                        }} opacity-50 rounded-full"
                      ></span>
                      <span
                        class="relative flex  {{
                          order.status === 'approved'
                            ? 'text-[#027A48]'
                            : 'text-red-700'
                        }} sm:text-[11px]"
                      >
                        {{ order.status | uppercase }}</span
                      >
                    </span>
                  </td>

                  <td
                    class="relative whitespace-nowrap border-b py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                  >
                    <div
                      class="relative inline-block w-fit cursor-pointer border-gray-200 bg-white text-left"
                    >
                      <app-dropdown
                        [id]="order.id"
                        [actionList]="initDropdownList(order)"
                      >
                      </app-dropdown>
                    </div>
                  </td>
                </tr>
              }
          </tbody>
        </table>
        <app-table-navigator
          *ngIf="totalCount$ | async as totalCount"
          [total]="totalCount"
          (onNavigation)="navigate($event)"
        ></app-table-navigator>
      </div>
    </div>
  </div>
</div>
}